const baseURL = process.env.REACT_APP_API_URL;

const isDev = process.env.NODE_ENV === "development";

export const signInUsingCredentialsAPI = () =>
  new Promise((resolve, reject) => {
    const request = `${baseURL}/api/signin`;
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: process.env.REACT_APP_USER_EMAIL,
        password: process.env.REACT_APP_USER_PASSWORD,
      }),
    };
    fetch(request, options)
      .then((response) => response.json())
      .then((response) => {
        localStorage.setItem("magnus:map:auth:token", response?.token);
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });

export const getSitesGridListAPI = () =>
  new Promise(async (resolve, reject) => {
    const token = localStorage.getItem("magnus:map:auth:token");
    if (!token) {
      reject();
    } else {
      try {
        // Make three API calls with take=50 and different skip values
        const requests = [
          `${baseURL}/api/tanks/gridList?skip=0&take=50&requireTotalCount=true&sort=[{"selector":"percent","desc":true}]&filter=[["service_type","=","1"]]`,
          `${baseURL}/api/tanks/gridList?skip=50&take=50&requireTotalCount=true&sort=[{"selector":"percent","desc":true}]&filter=[["service_type","=","1"]]`,
          `${baseURL}/api/tanks/gridList?skip=100&take=50&requireTotalCount=true&sort=[{"selector":"percent","desc":true}]&filter=[["service_type","=","1"]]`,
        ];

        const options = {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        };

        const responses = await Promise.all(
          requests.map((request) => fetch(request, options))
        );

        const results = await Promise.all(
          responses.map((response) => response.json())
        );

        // Merge all data arrays into one
        const mergedData = results.reduce((acc, result) => {
          const dataArray = result?.data || [];
          return acc.concat(dataArray);
        }, []);

        const mergedResponse = {
          ...results[0], // Use first response structure
          data: mergedData,
          totalCount: mergedData.length,
        };

        if (isDev) {
          console.log({ mergedResponse });
        }
        resolve(mergedResponse);
      } catch (error) {
        reject(error);
      }
    }
  });
